var map = {
	"./African.png": 687,
	"./All.png": 688,
	"./Bibimbap.svg": 689,
	"./Chinese .png": 690,
	"./Japanese.png": 691,
	"./Mexican.png": 692,
	"./Pastry.png": 693,
	"./Samosa.svg": 694,
	"./Thai.png": 695,
	"./b1.jpg": 123,
	"./b2.jpg": 124,
	"./b3.jpg": 125,
	"./b4.jpg": 126,
	"./b5.jpg": 127,
	"./baking.png": 696,
	"./birthday-cake.png": 697,
	"./bread.png": 698,
	"./breakfast.png": 699,
	"./bw_logos/African.png": 305,
	"./bw_logos/All.png": 306,
	"./bw_logos/Bakers.png": 307,
	"./bw_logos/Bread.png": 308,
	"./bw_logos/Chinese .png": 309,
	"./bw_logos/Cookie.png": 310,
	"./bw_logos/Drinks.png": 311,
	"./bw_logos/Japanese.png": 312,
	"./bw_logos/Mexican.png": 313,
	"./bw_logos/Near Me.png": 314,
	"./bw_logos/Pastry.png": 315,
	"./bw_logos/Price.png": 316,
	"./bw_logos/Rice and Egg.png": 317,
	"./bw_logos/Thai.png": 318,
	"./bw_logos/carrot.svg": 319,
	"./bw_logos/chef.png": 320,
	"./bw_logos/chef_b.png": 321,
	"./bw_logos/cloche.png": 322,
	"./bw_logos/cooking.png": 323,
	"./bw_logos/curry.png": 324,
	"./bw_logos/immediate.png": 325,
	"./bw_logos/indian.png": 326,
	"./bw_logos/italian .png": 327,
	"./bw_logos/now.svg": 328,
	"./bw_logos/price.svg": 329,
	"./cake.png": 700,
	"./colour icons.textClipping": 701,
	"./cookie.png": 702,
	"./cookies.png": 703,
	"./curry.png": 704,
	"./dairy.png": 705,
	"./donut.png": 706,
	"./dosa.png": 707,
	"./drink.png": 708,
	"./fried.png": 709,
	"./hamburger.png": 710,
	"./hat.png": 711,
	"./hummus.png": 712,
	"./indian.png": 713,
	"./instant-noodles.png": 714,
	"./italian.png": 715,
	"./macaroons.png": 716,
	"./paella.png": 717,
	"./pie.png": 718,
	"./pig.svg": 719,
	"./ranbir.jpg": 720,
	"./sauces.png": 721,
	"./seafood.png": 722,
	"./sushi.png": 723,
	"./vegetable.png": 724,
	"./wonton-noodles.png": 725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;